"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateInput = exports.DateClearButton = exports.DateSelectButton = void 0;
var react_1 = __importStar(require("react"));
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var TextInput_1 = require("../TextInput");
var useDateFormatter_1 = require("../DateModules/useDateFormatter");
var DatePicker_1 = require("../DatePicker");
var css_1 = require("@emotion/css");
var messages = __importStar(require("../DateModules/translations"));
var design_system_popovers_1 = require("@contrast-security-inc/design-system-popovers");
var useKeyboardAccesibility_1 = require("../DateModules/useKeyboardAccesibility");
var dateInputStyles = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* stylelint-disable-next-line selector-no-vendor-prefix */\n  input::placeholder,\n  input::-webkit-input-placeholder {\n    text-transform: uppercase;\n  }\n"], ["\n  /* stylelint-disable-next-line selector-no-vendor-prefix */\n  input::placeholder,\n  input::-webkit-input-placeholder {\n    text-transform: uppercase;\n  }\n"])));
var dateClearButtonStyles = function (isDisabled, selectedTheme) { return (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: ", ";\n\n  &:focus-visible {\n    border-radius: 6px;\n    border-color: ", ";\n    outline: unset;\n  }\n"], ["\n  cursor: ", ";\n\n  &:focus-visible {\n    border-radius: 6px;\n    border-color: ", ";\n    outline: unset;\n  }\n"])), isDisabled ? 'not-allowed' : 'pointer', (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.turquoise70, dark: design_system_foundations_1.darkTheme.color.blueGray50 })); };
var dateSelectButtonStyles = function (isDisabled) { return (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: unset;\n  border: 1px solid transparent;\n  padding: 0.5rem;\n  display: flex;\n  margin-right: 0.5rem;\n  cursor: ", ";\n"], ["\n  background-color: unset;\n  border: 1px solid transparent;\n  padding: 0.5rem;\n  display: flex;\n  margin-right: 0.5rem;\n  cursor: ", ";\n"])), isDisabled ? 'not-allowed' : 'pointer'); };
var iconColor = function (selectedTheme) { return (selectedTheme === 'dark' ? 'neutral50' : 'neutral80'); };
exports.DateSelectButton = (0, react_1.forwardRef)(function (_a, ref) {
    var onClick = _a.onClick, testId = _a.testId, isDisabled = _a.isDisabled;
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var formatMessage = (0, design_system_foundations_1.useLocalizationContext)().formatMessage;
    return (react_1.default.createElement("button", { tabIndex: -1, "aria-label": formatMessage(messages, 'calendar'), "data-testid": "".concat(testId, "-calendar-button"), type: "button", ref: ref, className: dateSelectButtonStyles(isDisabled), onClick: onClick },
        react_1.default.createElement(design_system_foundations_1.IconCalendar, { size: "sm", color: iconColor(selectedTheme) })));
});
exports.DateSelectButton.displayName = 'DateSelectButton';
exports.DateClearButton = (0, react_1.forwardRef)(function (_a, ref) {
    var onClick = _a.onClick, testId = _a.testId, isDisabled = _a.isDisabled;
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var formatMessage = (0, design_system_foundations_1.useLocalizationContext)().formatMessage;
    return (react_1.default.createElement("button", { "aria-label": formatMessage(messages, 'clearDate'), type: "button", "data-testid": "".concat(testId, "-clear-button"), ref: ref, className: (0, css_1.cx)(dateSelectButtonStyles(isDisabled), dateClearButtonStyles(isDisabled, selectedTheme)), onClick: onClick },
        react_1.default.createElement(design_system_foundations_1.IconClose, { size: "sm", color: iconColor(selectedTheme) })));
});
exports.DateClearButton.displayName = 'DateClearButton';
var isBlurWithinDatePicker = function (event, popoverTrigger) {
    var popover = document.querySelector('[data-popper]');
    return (popover === null || popover === void 0 ? void 0 : popover.contains(event.relatedTarget)) || popoverTrigger === event.relatedTarget;
};
var createCustomEvent = function (date) {
    return Object.create(new Event('changeEvent'), {
        target: {
            value: { value: date },
        },
    });
};
var focusInput = function (event, containerRef) {
    var _a, _b;
    event.preventDefault();
    (_b = (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('input')) === null || _b === void 0 ? void 0 : _b.focus();
};
var blurInput = function (containerRef) {
    var _a, _b;
    (_b = (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('input')) === null || _b === void 0 ? void 0 : _b.blur();
};
exports.DateInput = (0, react_1.forwardRef)(function (_a, ref) {
    var value = _a.value, onChange = _a.onChange, _b = _a.testId, testId = _b === void 0 ? 'date-select' : _b, errorProp = _a.error, isDisabled = _a.isDisabled, initialMonth = _a.initialMonth, onClear = _a.onClear, minDate = _a.minDate, maxDate = _a.maxDate, className = _a.className, rest = __rest(_a, ["value", "onChange", "testId", "error", "isDisabled", "initialMonth", "onClear", "minDate", "maxDate", "className"]);
    var _c = (0, react_1.useState)(false), isOpen = _c[0], setIsOpen = _c[1];
    var _d = (0, react_1.useState)(), error = _d[0], setError = _d[1];
    var getDatePlaceholder = (0, design_system_foundations_1.useLocalizationContext)().getDatePlaceholder;
    var format = getDatePlaceholder();
    var containerRef = (0, react_1.useRef)(null);
    var _e = (0, design_system_popovers_1.usePopover)({ hasArrow: true, placement: 'bottom-end' }), popoverTriggerProps = _e.popoverTriggerProps, popoverProps = _e.popoverProps;
    var handleChange = function (date) {
        onChange(createCustomEvent(date), date);
        setError('');
    };
    var accesibleKeyDown = (0, useKeyboardAccesibility_1.useKeyboardAccesibility)({
        currentValue: value !== null && value !== void 0 ? value : new Date(),
        minDate: minDate,
        maxDate: maxDate,
        handleChange: handleChange,
    }).onKeyDown;
    var _f = (0, useDateFormatter_1.useDateFormatter)({
        value: value,
        onChange: handleChange,
        onError: setError,
    }), inputValue = _f.inputValue, onInputChange = _f.onInputChange;
    var handleFocus = function () {
        setIsOpen(true);
    };
    var handleBlur = function (event) {
        if (isBlurWithinDatePicker(event, popoverProps.referenceElement)) {
            return;
        }
        setIsOpen(false);
    };
    var handleDateSelected = function (date) {
        onChange(createCustomEvent(date), date);
        setError('');
        setIsOpen(false);
    };
    var handleKeyDown = function (event) {
        if (event.key === 'Escape') {
            setIsOpen(false);
            blurInput(containerRef);
            return;
        }
        if (event.code === 'Space' || event.key === 'Space') {
            event.preventDefault();
            setIsOpen(false);
            blurInput(containerRef);
            return;
        }
        setIsOpen(true);
        accesibleKeyDown(event);
    };
    var handleClear = function (event) {
        // Call handleChange with undefined to properly clear the date
        handleChange(undefined);
        // Focus the input after clearing
        focusInput(event, containerRef);
        // Call the onClear callback if provided
        if (onClear) {
            onClear();
        }
    };
    var getContainerProps = function () {
        if (isDisabled) {
            return {
                onFocus: undefined,
                onBlur: handleBlur,
                onKeyDown: undefined,
            };
        }
        return {
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
        };
    };
    return (react_1.default.createElement(TextInput_1.TextInput, __assign({}, rest, { isDisabled: isDisabled, testId: testId, placeholder: format, onChange: onInputChange, ContainerProps: getContainerProps(), autoComplete: "off", value: inputValue, containerRef: containerRef, className: (0, css_1.cx)(className, 'ds-date-input', dateInputStyles), ref: ref, type: "text", error: errorProp || error, endAdornment: react_1.default.createElement(react_1.default.Fragment, null,
            inputValue ? (react_1.default.createElement(exports.DateClearButton, { testId: testId, isDisabled: isDisabled, onClick: !isDisabled ? handleClear : undefined, ref: popoverTriggerProps.ref })) : (react_1.default.createElement(exports.DateSelectButton, { ref: popoverTriggerProps.ref, testId: testId, isDisabled: isDisabled, onClick: !isDisabled
                    ? function (event) {
                        focusInput(event, containerRef);
                    }
                    : undefined })),
            react_1.default.createElement(design_system_popovers_1.Popover, __assign({}, popoverProps, { isOpen: isOpen, offset: [4, 12], "data-popper": true }), isOpen && (react_1.default.createElement(DatePicker_1.DatePicker, { date: value, onDateSelected: handleDateSelected, testId: "".concat(testId, "-date-picker"), initialMonth: initialMonth, minDate: minDate, maxDate: maxDate })))) })));
});
exports.DateInput.displayName = 'DateInput';
var templateObject_1, templateObject_2, templateObject_3;
